import React, { useState } from 'react';
import { Printer, Loader2 } from "lucide-react";
import { pdf } from '@react-pdf/renderer';

const PrinterButton = ({ 
  // Function that returns the PDF component with data
  getPDFComponent,
  // Optional custom filename without extension
  filename = 'document',
  // Optional function to fetch additional data before generating PDF
  fetchData,
  // Optional custom error handler
  onError,
  // Optional custom classes for the button
  className = "text-gray-600 hover:bg-gray-100 p-2 rounded-full transition-colors duration-300",
  // Optional custom size for the icon
  iconSize = 20
}) => {
  const [isLoading, setIsLoading] = useState(false);

  const handlePrintPDF = async () => {
    setIsLoading(true);
    
    try {
      // If fetchData is provided, get the additional data first
      let data = {};
      if (fetchData) {
        data = await fetchData();
      }

      // Get the PDF component with the data
      const PDFComponent = await getPDFComponent(data);
      
      // Generate the PDF blob
      const blob = await pdf(PDFComponent).toBlob();
      
      // Create and trigger download
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `${filename}.pdf`;
      document.body.appendChild(a);
      a.click();
      
      // Cleanup
      URL.revokeObjectURL(url);
      document.body.removeChild(a);
    } catch (error) {
      console.error('Error generating PDF:', error);
      if (onError) {
        onError(error);
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <button
      className={className}
      onClick={handlePrintPDF}
      disabled={isLoading}
      title="Export as PDF"
    >
      {isLoading ? (
        <Loader2 size={iconSize} className="animate-spin" />
      ) : (
        <Printer size={iconSize} />
      )}
    </button>
  );
};

export default PrinterButton;